import { c as _c } from "react/compiler-runtime";
import { DataFileInterface } from '@systemeio/file-manager';
import { CheckCircleIcon, Download01Icon, Trash02Icon } from '@systemeio/icons';
import React from 'react';
import { Button, Tooltip } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export type FileListItemType = {
  file: Pick<DataFileInterface, 'id' | 'name' | 'filename' | 'path'>;
  progress?: number;
  disabled?: boolean;
  uploaded?: boolean;
};
export const FileListItem = t0 => {
  const $ = _c(41);
  const {
    file,
    progress,
    disabled,
    uploaded,
    onDelete
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== progress) {
    t1 = progress !== undefined && <span className="text-text-tertiary text-sm">{progress}%</span>;
    $[0] = progress;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== uploaded) {
    t2 = uploaded && <CheckCircleIcon className="text-icon-success size-4" />;
    $[2] = uploaded;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = file.name;
  let t4;
  if ($[4] !== t) {
    t4 = t("global.download");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      className: "w-fit max-w-full"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = disabled || undefined;
  let t7;
  if ($[7] !== t) {
    t7 = t("global.download");
    $[7] = t;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== file.path) {
    t8 = <a href={file.path} rel="noreferrer" target="_blank" />;
    $[9] = file.path;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Download01Icon />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t10 = <Button aria-disabled={t6} aria-label={t7} render={t8} size="icon-xs" variant="ghost-color">{t9}</Button>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== disabled || $[17] !== t10 || $[18] !== t4) {
    t11 = <Tooltip mode="hover" label={t4} disabled={disabled} triggerProps={t5}>{t10}</Tooltip>;
    $[16] = disabled;
    $[17] = t10;
    $[18] = t4;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t("global.delete");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t) {
    t13 = t("global.delete");
    $[22] = t;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== onDelete) {
    t14 = () => onDelete();
    $[24] = onDelete;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Trash02Icon />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== disabled || $[28] !== t13 || $[29] !== t14) {
    t16 = <Button aria-label={t13} disabled={disabled} onClick={t14} size="icon-xs" variant="destructive-ghost">{t15}</Button>;
    $[27] = disabled;
    $[28] = t13;
    $[29] = t14;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== disabled || $[32] !== t12 || $[33] !== t16) {
    t17 = <Tooltip mode="hover" label={t12} disabled={disabled}>{t16}</Tooltip>;
    $[31] = disabled;
    $[32] = t12;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== file.name || $[36] !== t1 || $[37] !== t11 || $[38] !== t17 || $[39] !== t2) {
    t18 = <div className="flex flex-row gap-2 break-all">{t1}{t2}{t3}{t11}{t17}</div>;
    $[35] = file.name;
    $[36] = t1;
    $[37] = t11;
    $[38] = t17;
    $[39] = t2;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
};